import { useEffect,  useState } from 'react'

function useScrollbarVisibility() {

  const [scrollbarsVisible, setScrollbarsVisible] = useState(false);
  let timeout = null

  useEffect(() => {
    timeout = setInterval(() => {
      window.innerHeight > document.body.clientHeight
    })
    return () => {
      clearInterval(timeout)
    }
  }, []);

  return scrollbarsVisible;
}

export default useScrollbarVisibility;